import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-catalogue]')) return;

  addEventListeners();
}

function addEventListeners() {
  catalogueToggleFiltersOnMobile();
  catalogueDatalayer();
}

function catalogueToggleFiltersOnMobile() {
  const catalogueNavFilters = $('[data-au-catalogue-nav-filters]');
  const catalogueNavFiltersShow = 'au-catalogue__nav-filters--show';
  $$('[data-au-catalogue-nav-toggle-filters]').forEach((toggleFilters) => {
    toggleFilters.addEventListener('click', () => {
      const expand = catalogueNavFilters.classList.contains(catalogueNavFiltersShow) ? 'contraer' : 'expandir';
      catalogueNavFilters.classList.toggle(catalogueNavFiltersShow);
      document.body.classList.toggle('au-overflow-hidden');

      // datalayer of filter trigger button on mobile
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id: `filtrar productos_${expand}`,
      });
    });
  });
}

function catalogueDatalayer() {
  // datalayer of clean filters button
  $('[data-au-catalogue-clean-all]').addEventListener('click', (e) => {
    const titleText = e.target.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]')
      ? e.target.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]').innerText
      : '';
    const clickText = e.target.querySelector(':not([data-au-icon])').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickBoton',
      item_id,
    });
  });

  // datalayer of filter checkboxes
  $$('[data-au-checkbox]').forEach((chk) => {
    chk.addEventListener('change', (e) => {
      const titleText = e.target
        .closest('[data-au-collapsable-parent]')
        .querySelector('[data-au-collapsable-title-text]').innerText;
      const clickText = e.target.closest('[data-au-checkbox]').querySelector('label').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickFiltro',
        item_id,
      });
    });
  });

  // datalayer of cards
  $$(
    '[data-au-catalogue] [data-au-datalayer-card-vertical], [data-au-catalogue] [data-au-datalayer-product-card]',
  ).forEach((card) => {
    card.addEventListener('click', (e) => {
      const keywordSearch = $('[data-au-catalogue] [data-au-search-bar-float-input] input').value;
      const isProductCard = e.target.dataset.auDatalayerProductCard !== undefined;
      const cardTitle = isProductCard
        ? e.target.closest('[data-au-product-card]').querySelector('[data-au-product-card-title]')
        : e.target.closest('[data-au-media-card-vertical]').querySelector('[data-au-media-card-vertical-title]');
      const cardTitleText = cardTitle.innerText;

      const item_id = keywordSearch
        ? `${removeAccentMarkAndUppercase(keywordSearch)}_${removeAccentMarkAndUppercase(cardTitleText)}`
        : `${removeAccentMarkAndUppercase(cardTitleText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id,
      });
    });
  });
}

export default { init };
